<div
  #dropdownTrigger="rtOverlayOrigin"
  [class.no-left-padding]="noLeftPadding"
  class="input-container"
  rt-overlay-origin
  layout-horizontal
  layout-align-items-center
>
  <div *ngIf="currentOption" class="input-mask" padding-lr-small-x>
    {{ currentOption.label }}
  </div>
  <rt-input
    [class.empty]="!currentOption"
    [class.dropdownOpened]="dropdownOpen"
    [formControl]="valueControl"
    [placeholder]="placeholder"
    [hasDropdownIndicator]="true"
    [invalid]="invalid"
    type="number"
    (valueChange)="onInputChange($event)"
    (click)="toggleDropdown()"
    variant="rounded"
  >
  </rt-input>
</div>
<ng-template
  #dropdown="rtConnectedOverlay"
  [origin]="dropdownTrigger"
  [width]="dropdownWidth"
  [positions]="dropdownPositions"
  [open]="dropdownOpen"
  (backdropClick)="toggleDropdown(false)"
  rt-connected-overlay
  hasBackdrop
>
  <rt-input-with-select-dropdown
    [currentOption]="currentOption!"
    [maxHeight]="dropdownMaxHeight"
    [options]="options"
    (valueChanges)="onValueSelect($event); toggleDropdown(false)"
  >
  </rt-input-with-select-dropdown>
</ng-template>
